import { render, staticRenderFns } from "./Farm.vue?vue&type=template&id=3deda20f&scoped=true&"
import script from "./Farm.vue?vue&type=script&lang=ts&"
export * from "./Farm.vue?vue&type=script&lang=ts&"
import style0 from "./Farm.vue?vue&type=style&index=0&id=3deda20f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deda20f",
  null
  
)

export default component.exports